﻿import React, { useState, useReducer, useEffect, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  Editing,
  RequiredRule,
  HeaderFilter,
  Button,
  Scrolling,
  FilterRow,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import DropDownBox from "devextreme-react/drop-down-box";
import { confirm, custom } from "devextreme/ui/dialog";
import _ from "lodash";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import { CONFIG } from "./config";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import { LoadPanel } from "devextreme-react/load-panel";
import { CheckBox } from "devextreme-react/check-box";
import { Popup } from "devextreme-react/popup";
import * as action from "../../actions/siteDetails";
import * as utils from "../../common/utils";
import { postUserLog } from "../../actions/common";
import { getUpdatedRecord } from "../../common/utils";
import {
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
} from "../../common/utils";
import config from "../../common/config";
import NEXUS_CONST from "../../common/constants";
import executeApiRequest from "../../common/executeApiRequest";

const initialState = {
  peopleData: [],
  userDetails: [],
  tiersData: null,
  userPrefSettings: null,
};

export default ({ siteId, tierId, isEditableFlag }) => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  //const apiData = _.deepClone(state.peopleData)
  let { peopleData, userDetails, tiersData, userPrefSettings } = state;
  const [pData, setPData] = useState([]);
  const [isLoadPanelVisible, setIsLoadPanelVisible] = useState(false);
  const [tiersLevelData, setTiersLevelData] = useState({});
  const [tiersLevelDataUpdated, setTiersLevelDataUpdated] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [userData, setUserData] = useState({});

  let [selectedId, setSelectedId] = useState(null);
  // const isEditable = userDetails ? utils.isEditable(userDetails) : null;
  let peopleGrid = { ...CONFIG.PEOPLE_GRID };
  const peopleDataGrid = useRef(null);
  const toggleLoadPanel = () => {
    setIsLoadPanelVisible(true);
  };
  const hidePopUp = () => {
    setIsLoadPanelVisible(false);
  };

  const widgetId = "people";
  const GRID_COLS = JSON.stringify([
    "id",
    "siteID",
    "tierID",
    "tierLevel",
    "tierName",
    "employeeID",
    "employeeName",
    "email",
    "role",
    "isGemba",
    "isAttendanceTracker",
  ]);
  const loggedinUser = get("hid");

  useEffect(() => {
    action.getUserData(dispatch, siteId);
    actions.fetchTiers(dispatch, siteId);
    actions.fetchPeopleList(dispatch, siteId);
  }, []);

  useEffect(() => {
    actions.fetchUserPref(
      dispatch,
      `=0&SiteUID=${siteId}&widgetID=${widgetId}`
    );
    return () => {
      actions.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId,
          tierId: 0,
          moduleName: widgetId,
          loggedinUser,
          prefSess: "userPrefSettings",
          GRID_COLS,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPrefSettings) set("userPrefSettings", userPrefSettings);
    if (
      peopleDataGrid &&
      peopleDataGrid.current &&
      peopleDataGrid.current.instance !== null &&
      userPrefSettings &&
      peopleData
    ) {
      applyUserPref(peopleDataGrid, userPrefSettings);
    }
  }, [peopleData, userDetails, tiersData, userPrefSettings]);

  useEffect(() => {
    if (peopleData.length) {
      setPData(peopleData);
      if (!isEditableFlag) {
        peopleGrid.editing.allowUpdating = false;
        peopleGrid.editing.allowAdding = false;
        peopleGrid.editing.allowDeleting = false;
      } else {
        peopleGrid.editing.allowUpdating = true;
        peopleGrid.editing.allowAdding = true;
        peopleGrid.editing.allowDeleting = true;
      }
    }
  }, [peopleData, peopleGrid, isEditableFlag]);

  useEffect(() => {
    if (tiersData && tiersData.length) {
      let distinctTierLevel = tiersData
        .map((tier) => tier.tierLevel)
        .filter((item, i, ar) => ar.indexOf(item) === i)
        .sort(); //new Set( tiersData.map((x) => { return x.tierLevel }));
      setTiersLevelData(distinctTierLevel);
      const TierIDDropdown = tiersData.map((e) => {
        return e.tierLevel;
      });

      let TierIDDropdownFiltered = [...new Set(TierIDDropdown)];

      let DD = TierIDDropdownFiltered.map((obj) => {
        return {
          value: `${obj}`,
        };
      });

      setTiersLevelDataUpdated(DD);
    }
  }, [tiersData]);

  function setStateValue(rowData, value) {
    rowData.CityID = null;
    this.defaultSetCellValue(rowData, value);
  }

  function getFilteredCities(options) {
    return {
      store: tiersData,
      filter: options.data ? ["tierLevel", "=", options.data.tierLevel] : null,
    };
  }

  function onEditorPreparing(e) {
    if (e.parentType === "dataRow" && e.dataField === "CityID") {
      e.editorOptions.disabled = typeof e.row.data.StateID !== "number";
    }
  }

  function selectedChanged(e) {}

  // const onRowUpdated = (data) => {
  //   let {
  //     email,
  //     employeeID,
  //     employeeName,
  //     role,
  //     id,
  //     isGemba,
  //     isAttendanceTracker,
  //     tierID,
  //     tierName,
  //     tierLevel,
  //   } = data.data;

  //   let input = {
  //     id: id || 0,
  //     siteID: siteId,
  //     tierID: tierID + "",
  //     tierName: tierName,
  //     employeeID: employeeID,
  //     employeeName: employeeName,
  //     email: email,
  //     role: role,
  //     isGemba: isGemba,
  //     isAttendanceTracker: isAttendanceTracker,
  //   };
  //   //if (role === 'Member' || role === 'Viewer') {
  //   //    actions.updatePeople(dispatch, input, siteId);
  //   //} else {

  //   //let isRoleExist = peopleData.findIndex(d => (d.role === role && id !== d.id));
  //   let list = peopleData
  //     .filter(
  //       (person) =>
  //         person.tierLevel == tierLevel &&
  //         person.employeeID === employeeID &&
  //         person.tierName.toLowerCase() === tierName.toLowerCase()
  //     )
  //     .map(function (item) {
  //       return { value: item.employeeID, text: item.tierID };
  //     });

  //   if (list.length > 1) {
  //     //alert("already user exist for this site", "Alert")
  //     userExistsDialog.show().then((dialogResult) => {
  //       actions.fetchPeopleList(dispatch, siteId);
  //     });
  //     //let result = confirm(role + " already exist for this site, Do you want to change it?", "Confirm changes");
  //     //result.then((res) => {
  //     //    if (res)
  //     //        actions.updatePeople(dispatch, input, siteId);
  //     //    else
  //     //  actions.fetchPeopleList(dispatch, siteId);

  //     //});
  //     //actions.fetchPeopleList(dispatch, siteId);
  //   } else {
  //     postUserLog({
  //       event: "Update People",
  //       data: {
  //         action: `${data.data.employeeName} got updated`,
  //         module: "Settings Screen",
  //         section: "UPDATE People",
  //         siteUId: siteId,
  //         widget: "",
  //       },
  //     });
  //     actions.updatePeople(dispatch, input, siteId);
  //   }

  //   //}
  // };

  const onRowUpdating = (data) => {
    let oldData = data.oldData;
    let newData = data.newData;
    let diffVal = getUpdatedRecord(oldData, newData);

    let {
      email,
      employeeID,
      employeeName,
      role,
      id,
      isGemba,
      isAttendanceTracker,
      tierID,
      tierName,
      tierLevel,
    } = newData;

    let input = {
      id: oldData.id || 0,
      siteID: siteId,
      tierID: tierID != undefined ? tierID + "" : oldData.tierID + "",
      tierName: tierName != undefined ? tierName : oldData.tierName,
      employeeID: employeeID != undefined ? employeeID : oldData.employeeID,
      employeeName:
        employeeName != undefined ? employeeName : oldData.employeeName,
      email: email != undefined ? email : oldData.email,
      role: role != undefined ? role : oldData.role,
      isGemba: isGemba != undefined ? isGemba : oldData.isGemba,
      isAttendanceTracker:
        isAttendanceTracker != undefined
          ? isAttendanceTracker
          : oldData.isAttendanceTracker,
    };
    let list = peopleData
      .filter(
        (person) =>
          person.tierLevel == input.tierLevel &&
          person.employeeID === input.employeeID &&
          person.tierName.toLowerCase() === input.tierName.toLowerCase()
      )
      .map(function (item) {
        return { value: item.employeeID, text: item.tierID };
      });

    if (list.length > 1) {
      userExistsDialog.show().then((dialogResult) => {
        actions.fetchPeopleList(dispatch, siteId);
      });
    } else {
      Object.keys(diffVal).map((v) => {
        postUserLog({
          event: "People Update",
          data: {
            action: `Updated ${v.toUpperCase()} from ${diffVal[v].oldV} to ${
              diffVal[v].newV
            } of ${input.employeeName} user`,
            module: "Settings",
            section: "Manage People",
            siteUId: siteId,
            widget: "",
          },
        });
      });
      actions.updatePeople(dispatch, input, siteId);
    }
  };
  const onInitNewRow = (e) => {
    e.data.isGemba = true;
    e.data.isAttendanceTracker = true;
    e.data.role = "Member";
  };
  const onRowInserted = (data) => {
    let {
      email,
      employeeID,
      employeeName,
      role,
      isGemba = false,
      isAttendanceTracker = false,
      tierID,
      tierName,
      tierLevel,
    } = data.data;

    let input = {
      id: 0,
      siteID: siteId,
      tierID: tierID + "",
      tierName: tierName,
      employeeID: employeeID,
      employeeName: employeeName,
      email: email,
      role: role,
      isGemba: isGemba,
      isAttendanceTracker: isAttendanceTracker,
    };

    //if (role === 'Member') {
    //    actions.updatePeople(dispatch, input, siteId);
    //} else {

    //let isRoleExist = peopleData.findIndex(d => (d.role === role && d.employeeID === employeeID));
    let list = peopleData
      .filter(
        (person) =>
          person.tierLevel == tierLevel &&
          person.employeeID === employeeID &&
          person.tierName.toLowerCase() === tierName.toLowerCase()
      )
      .map(function (item) {
        return { value: item.employeeID };
      });

    if (list.length > 1) {
      // alert("already user exist for this site", "Alert")
      userExistsDialog.show().then((dialogResult) => {
        actions.fetchPeopleList(dispatch, siteId);
      });
      //let result = confirm(role + " already exist for this site, Do you want to change it?", "Confirm changes");
      //result.then((res) => {
      //    if (res)
      //        actions.updatePeople(dispatch, input, siteId);
      //    else actions.fetchPeopleList(dispatch, siteId);

      //});
    } else {
      postUserLog({
        event: "People Create",
        data: {
          action: `${data.data.employeeName} got added`,
          module: "Settings",
          section: "Manage People",
          siteUId: siteId,
          widget: "",
        },
      });
      actions.updatePeople(dispatch, input, siteId);
    }
  };

  const onRowRemoved = (data) => {
    postUserLog({
      event: "People Delete",
      data: {
        action: `${data.data.employeeName} got deleted`,
        module: "Settings",
        section: "Manage People",
        siteUId: siteId,
        widget: "",
      },
    });
    actions.deletePeople(dispatch, data.data.id, siteId);
  };

  const handlers = {
    // onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
    onRowInserted: onRowInserted,
  };

  let userExistsDialog = custom({
    title: "Info",
    messageHtml: "<b>User already exists for this Tier</b>",
    buttons: [
      {
        text: "OK",
        onClick: (e) => {
          return { buttonText: e.component.option("text") };
        },
      },
    ],
  });
  let noUserExistsDialog = custom({
    title: "Info",
    messageHtml: "<b>No Record Found</b>",
    buttons: [
      {
        text: "OK",
        onClick: (e) => {
          return { buttonText: e.component.option("text") };
        },
      },
    ],
  });

  let invalidInputDialog = custom({
    title: "Info",
    messageHtml: "<b>Invalid Search Input</b>",
    buttons: [
      {
        text: "OK",
        onClick: (e) => {
          return { buttonText: e.component.option("text") };
        },
      },
    ],
  });

  const onValueChanged = (eVal, id) => {
    let searchText = eVal.value.trim();

    if (searchText) {
      userDetails = [];
      let isUserExist = peopleData.some((pData) => {
        if (id === "employeeID") {
          //if (pData.employeeID.toLowerCase() == eVal.value.toLowerCase()) {
          //    return true;
          //}
        }
        if (id === "employeeName") {
          //  if (pData.employeeName.toLowerCase() == eVal.value.toLowerCase()) {
          //       return true;
          //  }
        }
        if (id === "email") {
          //  if (pData.email.toLowerCase() == eVal.value.toLowerCase()) {
          //      return true;
          //  }
        }

        return false;
      });
      if (isUserExist) {
        userExistsDialog.show().then((dialogResult) => {
          peopleDataGrid.current.instance.refresh(true);
        });
      } else {
        toggleLoadPanel();
        // const url = "Settings/getUsersBySearch?key=" + id + "&value=";
        // let URL = url + searchText;
        // let method = "get";
        // AsyncCallHandler(URL, method).then((res) => {
        //   if (res.data) {
        //     hidePopUp();
        //     if (res.data.length > 1) {
        //       populateUsers(res.data);
        //     } else {
        //       populateSelectedData(res.data[0]);
        //     }
        //   } else {
        //     hidePopUp();
        //     noUserExistsDialog.show().then();
        //   }
        //   dispatch({ type: "GET_USER_DETAILS", payload: res.data });
        // });

        let URL = `${window.ENV.SPA_AUTHORITY}${
          NEXUS_CONST.SEARCH_USER_IDENTITY
        }?query=${searchText}&projectId=${utils.get("tenantId")}&type=USER`;
        let method = "get";
        executeApiRequest({
          url: URL,
          method: method,
          accessToken: utils.get("accessToken"),
        })
          .then((res) => {
            if (res.data && res.data.results) {
              hidePopUp();
              if (res.data.results.length > 1) {
                populateUsers(res.data.results);
              } else {
                populateSelectedData(res.data.results[0]);
              }
            } else {
              hidePopUp();
              noUserExistsDialog.show().then();
            }
            dispatch({ type: "GET_USER_DETAILS", payload: res.data.results });
          })
          .catch((err) => {
            console.error(err);
            hidePopUp();
          });
      }
    } else {
      invalidInputDialog.show().then((dialogResult) => {
        peopleDataGrid.current.instance.refresh(true);
      });
    }
  };

  const populateUsers = (data) => {
    setUserData(data);
    togglePopup();
  };
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const cloneRowData = (e) => {
    togglePopup();
    populateSelectedData(e.row.data);
  };

  const startEdit = (e) => {
    setSelectedId(e.rowIndex);
  };
  const oneditorPrepared = (e) => {
    if (e.dataField === "employeeID" && e.parentType === "dataRow") {
      e.editorOptions.onValueChanged = (e) => onValueChanged(e, "employeeID");
    } else if (e.dataField === "employeeName" && e.parentType === "dataRow") {
      e.editorOptions.onValueChanged = (e) => onValueChanged(e, "employeeName");
    } else if (e.dataField === "email" && e.parentType === "dataRow") {
      e.editorOptions.onValueChanged = (e) => onValueChanged(e, "email");
    }
  };

  const populateSelectedData = (data) => {
    const fullName = `${data.familyName}, ${data.givenName}`;
    if (selectedId == null) {
      peopleDataGrid.current.instance.cellValue(0, "employeeID", data.username);
      peopleDataGrid.current.instance.cellValue(0, "employeeName", fullName);
      peopleDataGrid.current.instance.cellValue(0, "email", data.email);
    } else {
      peopleDataGrid.current.instance.cellValue(
        selectedId,
        "employeeID",
        data.username
      );
      peopleDataGrid.current.instance.cellValue(
        selectedId,
        "employeeName",
        fullName
      );
      peopleDataGrid.current.instance.cellValue(
        selectedId,
        "email",
        data.email
      );
    }
  };
  return (
    <>
      {/* {(!pData.length || "") && (
        <div
          class="dx-item-content dx-toolbar-item-content plus-icon"
          onClick={() => {
            pData.push({
              id: null,
              siteID: null,
              tierID: null,
              employeeID: null,
              employeeName: null,
              email: null,
              role: null,
              isGemba: false,
              isAttendanceTracker: false,
            });
            setPData([...pData]);
          }}
        >
          <div
            class="dx-datagrid-toolbar-button dx-edit-button dx-datagrid-addrow-button dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-icon dx-button-has-text dx-state-hover"
            aria-label="Add a row"
            tabindex="0"
            role="button"
          >
            <div class="dx-button-content">
              <i class="dx-icon dx-icon-edit-button-addrow"></i>
            </div>
          </div>
        </div>
      )} */}

      <div id="data-grid-demo">
        {tiersData && peopleData && userDetails && utils && peopleGrid && (
          <DataGrid
            ref={peopleDataGrid}
            dataSource={pData}
            keyExpr="id"
            showBorders={true}
            allowColumnReordering={true}
            onEditorPreparing={oneditorPrepared}
            onRowClick={startEdit}
            onRowUpdating={onRowUpdating}
            onCellPrepared={function (e) {
              if (
                e.rowType === "filter" &&
                (e.column.dataField === "isGemba" ||
                  e.column.dataField === "role")
              )
                e.cellElement.firstChild.style.display = "none";
              if (
                e.rowType === "filter" &&
                (e.column.dataField === "isAttendanceTracker" ||
                  e.column.dataField === "role")
              )
                e.cellElement.firstChild.style.display = "none";
            }}
            {...peopleGrid}
            onInitNewRow={onInitNewRow}
            {...handlers}
            onContentReady={(e) => setGridUserPrefs(e, widgetId)}
            onColumnsChanging={(e) => setGridWidthPrefs(e, widgetId)}
          >
            <Paging defaultPageSize={5} />
            <Pager
              visible={true}
              allowedPageSizes={[5, 10, 20, 50]}
              showPageSizeSelector={true}
              showInfo={true}
              showNavigationButtons={true}
            />
            <Column
              dataField="id"
              caption="Id"
              dataType="number"
              visible={false}
              allowEditing={false}
            ></Column>
            <Column
              dataField="siteID"
              caption="SiteId"
              visible={false}
              allowEditing={false}
            ></Column>

            <Column
              dataField="tierID"
              caption="Tier ID"
              dataType="number"
              visible={false}
            >
              <Lookup
                dataSource={tiersData}
                valueExpr="tierID"
                displayExpr="tierID"
              />
              {/* <RequiredRule />*/}
            </Column>
            <Column
              dataField="tierLevel"
              caption="Tier Level"
              dataType="number"
              setCellValue={setStateValue}
            >
              <Lookup
                dataSource={tiersLevelDataUpdated}
                valueExpr="value"
                displayExpr="value"
              />
              <RequiredRule />
            </Column>
            <Column dataField="tierName" caption="Tier Name">
              <Lookup
                dataSource={getFilteredCities}
                valueExpr="tierName"
                displayExpr="tierName"
              />
              <RequiredRule />
            </Column>
            <Column
              dataField="employeeID"
              caption="EID"
              width={100}
              //cssClass={animate}

              // editorOptions={{
              //   onValueChanged: (eVal) => onValueChanged(eVal, "employeeID"),
              // }}
            >
              <RequiredRule />
            </Column>
            <Column
              dataField="employeeName"
              caption="Employee Name"
              // editorOptions={{
              //   onValueChanged: (eVal) => onValueChanged(eVal, "employeeName"),
              // }}
            >
              <RequiredRule />
            </Column>
            <Column
              dataField="email"
              caption="Email"
              // dataType="email"
              // editorOptions={{
              //   onValueChanged: (eVal) => onValueChanged(eVal, "email"),
              // }}
            >
              <RequiredRule />
            </Column>
            <Column dataField="role" caption="Role">
              <Lookup
                dataSource={CONFIG.LOOKUPROLEDATASOURCECONFIG}
                valueExpr="name"
                displayExpr="name"
              />
              <RequiredRule />
            </Column>
            {config.DEV_DISPLAY_OPTIONS && (
              <Column
                dataField="isGemba"
                caption="Show in Gemba"
                dataType="boolean"
              >
                <HeaderFilter dataSource={CONFIG.ISGEMBACONFIG} />

                <CheckBox />
              </Column>
            )}
            {config.DEV_DISPLAY_OPTIONS && (
              <Column
                dataField="isAttendanceTracker"
                caption="Show in Attendance List"
                dataType="boolean"
              >
                <HeaderFilter dataSource={CONFIG.ISGEMBACONFIG} />

                <CheckBox />
              </Column>
            )}
          </DataGrid>
        )}
        {isLoadPanelVisible && (
          <LoadPanel
            visible={isLoadPanelVisible}
            hideOnOutsideClick={true}
            onHiding={hidePopUp}
            showPane={true}
          />
        )}
        <Popup
          visible={showPopup}
          hideOnOutsideClick={true}
          showCloseButton={true}
          onHiding={togglePopup}
          showTitle={true}
          title="Information"
          width="50%"
          height="400px"
        >
          <DataGrid dataSource={userData} height="300px" showBorders={true}>
            <Scrolling mode="virtual" />
            <Column dataField="employeeId" caption="HID" />
            <Column dataField="name" caption="Name" />
            <Column dataField="mail" caption="Mail" />
            <Column type="buttons" width={110} caption="action">
              <Button text="Select" onClick={cloneRowData} />
            </Column>
          </DataGrid>
        </Popup>
      </div>
    </>
  );
};
